import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { useSelector, useDispatch } from 'react-redux'
import {reserveRoutes} from '../router/routeConfig'
import {useLocation} from 'react-router-dom'
import _ from 'lodash'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',        
    },
    stepper:{
        backgroundColor: theme.palette.secondary.light
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));



export default function HorizontalLabelPositionBelowStepper() {

    const classes = useStyles();
        
    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o)=>o.path === location.pathname)

    return (
        <div className={classes.root}>
            <Stepper activeStep={idx} alternativeLabel className={classes.stepper}>
                {reserveRoutes.map((route) => (
                    <Step key={route.path}>
                        <StepLabel>{route.name}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </div>   
    );
}